import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isSecondStep: false
};

const register = createSlice({
	name: 'register',
	initialState,
	reducers: {
		setIsSecondStepTrue: (state) => ({ ...state, isSecondStep: true }),
		setIsSecondStepFalse: (state) => ({ ...state, isSecondStep: false })
	}
});
export const { setIsSecondStepTrue, setIsSecondStepFalse } = register.actions;

export default register.reducer;
